import React, { FC } from 'react'
import { UIPlacement, UITrigger, PopoverComponent, FileWithPreview } from 'LibNeo'
import { FileItemWrapper, FilePreview, UploadPopoverOverlayStyled } from './styled'

interface FileItemProps {
	file: FileWithPreview
	isMobile: boolean
	isImage: boolean
	renderDeleteFileButton?: () => JSX.Element | null
}

export const FileView: FC<FileItemProps> = ({
	file,
	isMobile = false,
	isImage = false,
	children,
	renderDeleteFileButton,
}) => (
	<FileItemWrapper onClick={(e) => e.stopPropagation()} key={file.name}>
		{isImage && file.preview && !isMobile ? (
			<PopoverComponent
				trigger={UITrigger.HOVER}
				placement={UIPlacement.BOTTOM_LEFT}
				mouseEnterDelay={1}
				overlay={UploadPopoverOverlayStyled}
				content={
					<FilePreview withoutHeader>
						<img src={file.preview} alt={file.name} />
					</FilePreview>
				}
			>
				{children}
			</PopoverComponent>
		) : (
			children
		)}
		{renderDeleteFileButton && renderDeleteFileButton()}
	</FileItemWrapper>
)
